<template>
  <b-form-group
    label="Kalori Değeri"
    label-for="value"
  >
    <validation-provider
      #default="{ errors }"
      name="Kalori Değeri"
      rules="required"
    >
      <b-input-group>
        <b-form-input
          id="value"
          v-model="dataList[keyNumber].value"
          placeholder="Kalori Değeri"
        />
        <b-input-group-append is-text>
          Kcal
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'ValueText',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['productCalories/dataList']
    },
  },
}
</script>
